import { PricingSurveyEditorViewModel } from "src/app/surveys/pricing-survey/viewmodels/pricing.survey.editor.viewmodel";

export class SubmitPricingSurveyCommand {
  constructor(public survey: PricingSurveyEditorViewModel) { }
}
